import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "desktop-sidebar-collapsed"

export default class extends Controller {
  static targets = ["sidebar", "main", "content", "logo", "header", "collapseIcon", "expandIcon"]
  static values = {
    storageKey: { type: String, default: STORAGE_KEY },
  }

  connect() {
    this.collapsed = this.loadState()
    this.applyState()
  }

  toggle() {
    this.collapsed = !this.collapsed
    this.saveState()
    this.applyState()
  }

  loadState() {
    try {
      return localStorage.getItem(this.storageKeyValue) === "true"
    } catch {
      return false
    }
  }

  saveState() {
    try {
      localStorage.setItem(this.storageKeyValue, this.collapsed)
    } catch {
      // ignore
    }
  }

  applyState() {
    if (!this.hasSidebarTarget || !this.hasMainTarget) return

    if (this.collapsed) {
      this.sidebarTarget.classList.remove("md:w-80")
      this.sidebarTarget.classList.add("md:w-14")
      this.mainTarget.classList.remove("md:ml-80")
      this.mainTarget.classList.add("md:ml-14")
      this.contentTarget?.classList.add("hidden")
      this.logoTarget?.classList.add("hidden")
      this.headerTarget?.classList.replace("md:justify-between", "md:justify-center")
      this.headerTarget?.classList.remove("p-4")
      this.headerTarget?.classList.add("px-2", "py-4")
      this.collapseIconTarget?.classList.add("hidden")
      this.expandIconTarget?.classList.remove("hidden")
    } else {
      this.sidebarTarget.classList.remove("md:w-14")
      this.sidebarTarget.classList.add("md:w-80")
      this.mainTarget.classList.remove("md:ml-14")
      this.mainTarget.classList.add("md:ml-80")
      this.contentTarget?.classList.remove("hidden")
      this.logoTarget?.classList.remove("hidden")
      this.headerTarget?.classList.replace("md:justify-center", "md:justify-between")
      this.headerTarget?.classList.remove("px-2", "py-4")
      this.headerTarget?.classList.add("p-4")
      this.collapseIconTarget?.classList.remove("hidden")
      this.expandIconTarget?.classList.add("hidden")
    }
  }
}
